const educationData = [
  {
    title: "Delhi Public School",
    subtitle: "2005-2021",
    details: "Completed my schooling with a strong emphasis on science and mathematics.",
    position: { top: '45%', left: '10%' },
    cardAlignment: 'text-right',
    place: "DPS"
  },
  {
    title: "Bachelor of Science",
    subtitle: "University of Delhi, 2021-2024",
    details: "Specialized in Physical Science with a focus on Electronics.",
    position: { top: '25%', left: '40%' },
    cardAlignment: 'right sm:left',
    place: "Ramjas, DU"
  },
  {
    title: "B.S in Data Science",
    subtitle: "IIT Madras, Sep'2021- Apr'2026",
    details: "Pursued a rigorous, in-depth curriculum in Data Science and Applications.",
    position: { top: '45%', left: '70%' },
    cardAlignment: 'left',
    place: "IIT Madras"
  },
  {
    title: "The Journey Ahead",
    subtitle: "Let's see where life takes me...",
    details: "Eager to apply my skills in real-world scenarios and continuously learn.",
    position: { top: '40%', left: '92%' },
    cardAlignment: 'left',
    place: "..."
  },
];

export default educationData;